import keyMirror from "keymirror";

// Define action constants
const appConstants = keyMirror({
	SELECT_ACCOUNT: null,            // Selects an account
	RECEIVE_DATA: null,              // Loads our data
	RELOAD_DATA: null,               // General purpose reload, store should check key
	ACCOUNTS_SAVE_PENDING: null,
	ACCOUNTS_SAVE_SUCCESS: null,
	ACCOUNTS_SAVE_FAILURE: null,
	ACCOUNTS_RECEIVE_LINEITEMS: null,
	ACCOUNT_LINEITEM_DELETE_PENDING: null,
	ACCOUNT_LINEITEM_DELETE_SUCCESS: null,
	ACCOUNT_LINEITEM_DELETE_FAILURE: null,
	ACCOUNT_LINEITEM_SAVE_PENDING: null,
	ACCOUNT_LINEITEM_SAVE_SUCCESS: null,
	ACCOUNT_LINEITEM_SAVE_FAILURE: null,
	ACCOUNT_TRANSACTION_SAVE_SUCCESS: null,
	BUDGET_RECEIVE_DATA: null,
	BUDGET_ALLOCATIONS_SETORDER_PENDING: null,
	BUDGET_ALLOCATIONS_SETORDER_SUCCESS: null,
	BUDGET_ALLOCATIONS_SETORDER_FAILURE: null,
	BUDGET_ALLOCATIONS_TRANSFER_PENDING: null,
	BUDGET_ALLOCATIONS_TRANSFER_SUCCESS: null,
	BUDGET_ALLOCATIONS_TRANSFER_FAILURE: null,
	CATEGORY_DELETE_PENDING: null,
	CATEGORY_DELETE_SUCCESS: null,
	CATEGORY_DELETE_FAILURE: null,
	CATEGORY_RECEIVE_DATA: null,
	CATEGORY_SAVE_PENDING: null,
	CATEGORY_SAVE_SUCCESS: null,
	CATEGORY_SAVE_FAILURE: null,
	CURRENCYSTORE_DELETE_PENDING: null,
	CURRENCYSTORE_DELETE_SUCCESS: null,
	CURRENCYSTORE_DELETE_FAILURE: null,
	CURRENCY_INITIALIZE: null,
	CURRENCYSTORE_SAVE_PENDING: null,
	CURRENCYSTORE_SAVE_SUCCESS: null,
	CURRENCYSTORE_SAVE_FAILURE: null,
	USERSTORE_RECEIVE_USERPROFILE: null,
	FEATURE_RECEIVE_DATA: null,
	BUDGET_TEMPLATE_DELETE_PENDING: null,
	BUDGET_TEMPLATE_DELETE_SUCCESS: null,
	BUDGET_TEMPLATE_DELETE_FAILURE: null,
	BUDGET_TEMPLATE_RUN_PENDING: null,
	BUDGET_TEMPLATE_RUN_SUCCESS: null,
	BUDGET_TEMPLATE_RUN_FAILURE: null,
	BUDGET_TEMPLATE_SAVE_PENDING: null,
	BUDGET_TEMPLATE_SAVE_SUCCESS: null,
	BUDGET_TEMPLATE_SAVE_FAILURE: null,
	TAGSTORE_DELETE_PENDING: null,
	TAGSTORE_DELETE_SUCCESS: null,
	TAGSTORE_DELETE_FAILURE: null,
	TAGSTORE_RECEIVE_DATA: null,
	TAGSTORE_SAVE_PENDING: null,
	TAGSTORE_SAVE_SUCCESS: null,
	TAGSTORE_SAVE_FAILURE: null,
	USERPROFILE_UPDATE_PENDING: null,
	USERPROFILE_UPDATE_SUCCESS: null,
	USERPROFILE_UPDATE_FAILURE: null
});

const orderings = [
	{ value: "amount:asc", displayName: "Amount (ascending)" },
	{ value: "amount:desc", displayName: "Amount (descending)" },
	{ value: "name:asc", displayName: "Name (ascending)" },
	{ value: "name:desc", displayName: "Name (descending)" },
	{ value: "user", displayName: "User Defined" }
];

export { appConstants as default, orderings };



// WEBPACK FOOTER //
// ./Components/constants/AppConstants.jsx